module.exports = __webpack_public_path__ + "img/video_bg2.b97bdc2e.png";